import { useLocation, useNavigate } from 'react-router-dom';
import { LogOut, User } from 'lucide-react';
import { useAuthStore } from '@/stores/authStore';

const PAGE_TITLES: Record<string, string> = {
  '/dashboard': 'Dashboard',
  '/plans': 'Test Plans',
  '/runs': 'Run History',
  '/reports': 'Reports',
  '/environments': 'Environments',
  '/alerts': 'Alert Rules',
  '/schedules': 'Schedules',
  '/settings': 'Settings',
};

export function Topbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuthStore();

  const title = Object.entries(PAGE_TITLES).find(([path]) => location.pathname.startsWith(path))?.[1] ?? 'Meridian';

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <header className="h-14 flex items-center justify-between px-6 border-b border-border bg-background-secondary flex-shrink-0">
      <h1 className="text-base font-semibold text-text-primary">{title}</h1>

      <div className="flex items-center gap-3">
        {user && (
          <span className="text-sm text-text-secondary flex items-center gap-1.5">
            <User className="w-3.5 h-3.5" />
            {user.email}
          </span>
        )}
        <button
          onClick={handleLogout}
          className="flex items-center gap-1.5 text-sm text-text-secondary hover:text-error transition-colors"
          aria-label="Log out"
        >
          <LogOut className="w-4 h-4" />
        </button>
      </div>
    </header>
  );
}
